import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import * as styles from 'dygl/build/styles.css';
class App extends Component {
  render() {
    console.log(styles);
    return (
      <div className="App">
        <header className="App-header">
          <img src={logo} className={styles.fx} alt="logo" />
          <h1 className="App-title">Welcome to React</h1>
        </header>
        <p className="App-intro">
          To get started, edit <code>src/App.js</code> and save to reload.
        </p>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js